module.exports = __webpack_public_path__ + "4af53ba8ee3d7f21f8c8a58ab3de63d8.svg";